import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';

import type {
    GetSuggestedReplies_suggestedReplies as SuggestedReplies,
    GetSuggestedReplies_suggestedReplies_replies as SuggestedReply,
} from 'nutshell-graphql-types';

import {SuggestedReplyLabel, SuggestedReplyCards} from './index';

type Props = {
    suggestedReplies: SuggestedReplies | null | undefined;
    isLoading: boolean | null | undefined;
    onCardClicked: (reply: SuggestedReply) => void;
    variant?: 'full' | 'sparse';
};

export function SuggestedReplyContainer(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <StackLegacy spacing={4} isHorizontal={true}>
                <SuggestedReplyLabel />
            </StackLegacy>
            <SuggestedReplyCards
                suggestedReplies={props.suggestedReplies}
                isLoading={props.isLoading}
                onCardClicked={props.onCardClicked}
                variant={props.variant}
            />
        </StackLegacy>
    );
}
